import Model, { ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'
import TicketType from 'src/models/showing/TicketType'

export default class SeatChartAreaCategory extends Model {
  static name = 'SeatChartAreaCategory'

  static paginate = true
  static deletable = true
  static duplicatable = true
  static versioned = true

  static isConfiguration = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Ticketing]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      ticketTypes: {
        type: [TicketType],
        reference: true,
        default: () => ([])
      },
      excludeTicketTypes: {
        type: Boolean,
        default: false
      }
    }

    this.computed = {
      effectiveTicketTypeIds () {
        if (this.excludeTicketTypes) {
          return _.difference(this.configuration.ticketTypes?.data.map('id'), this.ticketTypeIds)
        } else {
          return this.ticketTypeIds
        }
      }
    }
  }

  seatAllowedForTicketType (ticketTypeId) {
    if (this.excludeTicketTypes) {
      return !_.includes(this.ticketTypeIds, ticketTypeId)
    } else if (!this.excludeTicketTypes) {
      return _.includes(this.ticketTypeIds, ticketTypeId)
    }
  }
}
